import React from 'react';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { thumbnailsPropTypes, thumbnailsDefaultProps } from '../propTypes';
import Thumbnail from './Thumbnail';
import { GRID_THUMBNAIL_HEIGHT, GRID_THUMBNAIL_WIDTH } from '../constants';

const Thumbnails = ({
  thumbnailList,
  mainImageList,
  selectedType,
  selectedThumbnailIndex,
  totalThumbnailsToShow,
  originalThumbnailCount,
  onThumbnailEvent,
  grid
}) => {
  const availableThumbnails = thumbnailList?.map((thumbnail, index) => ({
    ...thumbnail,
    isSelected: selectedThumbnailIndex === index
  }));
  const thumbnailCount = originalThumbnailCount || thumbnailList?.length;

  if (!thumbnailList?.length) {
    return (
      <Skeleton grow disablePadding>
        <SkeletonBlock aspect="wide" height={24} />
      </Skeleton>
    );
  }

  const gridStyles = grid
    ? { maxHeight: GRID_THUMBNAIL_HEIGHT, maxWidth: GRID_THUMBNAIL_WIDTH }
    : {};

  const gridClasses = [
    'sui-grid',
    'sui-gap-4',
    selectedType === 'CUSTOMER_IMAGE' && 'sui-overflow-auto',
    grid
      ? 'sui-grid-cols-2 md:sui-grid-cols-3 xl:sui-grid-cols-4 sui-p-6 sui-items-start sui-justify-items-stretch'
      : 'sui-grid-cols-7'
  ].filter(Boolean).join(' ');

  const displayedThumbnails = availableThumbnails.slice(0, totalThumbnailsToShow || thumbnailList.length);

  return (
    <div style={gridStyles} className={gridClasses}>
      {displayedThumbnails.map((thumbnail, thumbnailIndex) => (
        <Thumbnail
          key={`${thumbnail.id}-${thumbnailIndex}`}
          thumbnail={thumbnail}
          thumbnailIndex={thumbnailIndex}
          totalThumbnailsToShow={totalThumbnailsToShow}
          thumbnailCount={thumbnailCount}
          availableThumbnails={availableThumbnails}
          mainImageList={mainImageList}
          onThumbnailEvent={onThumbnailEvent}
          thumbnailSize={grid ? 'lg' : 'md'}
          grid={grid}
        />
      ))}
    </div>
  );
};

Thumbnails.propTypes = thumbnailsPropTypes;
Thumbnails.defaultProps = thumbnailsDefaultProps;

export default Thumbnails;